import { render, staticRenderFns } from "./PfUserActivityLog.vue?vue&type=template&id=51d3d358"
import script from "./PfUserActivityLog.vue?vue&type=script&lang=js"
export * from "./PfUserActivityLog.vue?vue&type=script&lang=js"
import style0 from "./PfUserActivityLog.vue?vue&type=style&index=0&id=51d3d358&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports